import Cookies from 'universal-cookie';
import { Store } from 'store/types';
import { CookiesEvents } from './cookies-constants';

export const cookies = (store: Store) => {
  store.on('@init', state => ({ ...state, cookies: {} }));

  store.on(CookiesEvents.set, (state, data) => ({
    ...state,
    cookies: new Cookies(data).getAll({ doNotParse: true }),
  }));

  store.on(CookiesEvents.update, (state, { key, value, params }) => {
    const cookie = new Cookies(state.cookies);
    cookie.set(key, value, params);

    return { ...state, cookies: cookie.getAll() };
  });
};
